import React from 'react';
import Footer from 'js/components/Footer';

export default () => <Footer />;
